var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E6F1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.11914H7.74001C8.82001 6.11914 9.67 7.03811 9.58 8.09543L8.75 17.9373C8.61 19.548 9.89999 20.9314 11.54 20.9314H22.19C23.63 20.9314 24.89 19.7654 25 18.3523L25.54 10.9413C25.66 9.30096 24.4 7.96696 22.73 7.96696H9.82001",
    stroke: "#3B58FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 25.8815C20.9404 25.8815 21.5 25.3285 21.5 24.6463C21.5 23.9641 20.9404 23.4111 20.25 23.4111C19.5596 23.4111 19 23.9641 19 24.6463C19 25.3285 19.5596 25.8815 20.25 25.8815Z",
    stroke: "#3B58FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 25.8815C12.9404 25.8815 13.5 25.3285 13.5 24.6463C13.5 23.9641 12.9404 23.4111 12.25 23.4111C11.5596 23.4111 11 23.9641 11 24.6463C11 25.3285 11.5596 25.8815 12.25 25.8815Z",
    stroke: "#3B58FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.0479H25",
    stroke: "#3B58FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/inventory-icon.2649a9ff765acc776d399c9056035e5f.svg";
export { ForwardRef as ReactComponent };